import i18n from 'live/services/i18n'

import React, { useState, useEffect } from 'react'
import { FieldRow, FieldValue, Field, InputContainer } from 'plugin-liverig/shared/asset/components/Fieldset'
import CustomDateInput from 'live/components/forms/ui/custom-react-datepicker-input'
import LiveSelect from 'live/components/forms/ui/select'
import ActionToggle from 'live/components/ui/action-toggle'
import DatePicker from 'react-datepicker'
import DateService from 'live/services/date'
import moment, { Moment } from 'moment'
import styled from 'styled-components'
import MaskedInput from 'react-maskedinput'

export function renderFormConfig(data, fieldProps, label, setData, inputProps, readOnly, formRowsConfig, state, setState) {
    return formRowsConfig.map(row => (
        <FieldRow className="Fieldset__FieldRow">
            {row.map(
                (formConfig, i) =>
                    formConfig.componentType == 'select' ?
                        <Field key={i} {...fieldProps(formConfig.label)}>
                            <label {...label(formConfig.label)}>
                                <span>{i18n(formConfig.label)}</span>
                            </label>
                            <LiveSelect
                                value={state[formConfig.property]}
                                disabled={false}
                                creatable={true}
                                placeholder={i18n(formConfig.placeHolder)}
                                options={formConfig.options}
                                onChange={(valueID, opt) => {
                                    const newData = { ...state, [formConfig.property]: valueID }
                                    setState(newData)
                                    setData(newData)
                                }}
                            />
                            <FieldValue className="Fieldset__Value">{state[formConfig.property] || '-'}</FieldValue>
                        </Field>
                        : formConfig.componentType == 'switch' ?
                            <Field key={i} {...fieldProps(formConfig.label)}>
                                <label {...label(formConfig.label)}>
                                    <span>{i18n(formConfig.label)}</span>
                                </label>
                                <ActionToggle
                                    active={state[formConfig.property] || false}
                                    onChange={() => {
                                        const newData = { ...state, [formConfig.property]: !state[formConfig.property] }
                                        setState(newData)
                                        setData(newData)
                                    }}
                                    disabled={false}
                                />
                            </Field>
                            : formConfig.componentType == 'number' ?
                                <Field key={i} {...fieldProps(formConfig.label)}>
                                    <label {...label(formConfig.label)}>
                                        <span>{i18n(formConfig.label)}</span>
                                    </label>
                                    <InputContainer className="Fieldset__InputContainer">
                                        <input
                                            type={"number"}
                                            step={0.1}
                                            onChange={(v: Object) => {
                                                const newData = { ...state, [formConfig.property]: v }
                                                setState(newData)
                                                setData(newData)
                                            }}
                                            {...inputProps(formConfig.property)}
                                            placeholder="-"
                                            disabled={readOnly}
                                            value={state[formConfig.property]}
                                        />
                                    </InputContainer>
                                    <FieldValue className="Fieldset__Value">{state[formConfig.property] || '-'}</FieldValue>
                                </Field>
                                : formConfig.componentType == 'text' ?
                                    <Field key={i} {...fieldProps(formConfig.label)}>
                                        <label {...label(formConfig.label)}>
                                            <span>{i18n(formConfig.label)}</span>
                                        </label>
                                        <InputContainer className="Fieldset__InputContainer">
                                            <input
                                                onChange={(v: Object) => {
                                                    const newData = { ...state, [formConfig.property]: v }
                                                    setState(newData)
                                                    setData(newData)
                                                }}
                                                {...inputProps(formConfig.property)}
                                                placeholder="-"
                                                disabled={readOnly}
                                                value={state[formConfig.property]}
                                            />
                                        </InputContainer>
                                        <FieldValue className="Fieldset__Value">{state[formConfig.property] || '-'}</FieldValue>
                                    </Field>
                                    : formConfig.componentType == 'date-picker' ?
                                        <Field className="field-date-picker" key={i} {...fieldProps(formConfig.label)}>
                                            <label {...label(formConfig.label)}>
                                                <span>{i18n(formConfig.label)}</span>
                                            </label>
                                            <CustomDatePicker
                                                id={formConfig.property}
                                                value={state[formConfig.property]}
                                                onChangeData={(v) => {
                                                    const newData = { ...state, [formConfig.property]: v }
                                                    setState(newData)
                                                    setData(newData)
                                                }}
                                                disabled={readOnly}
                                            />
                                            <FieldValue className="Fieldset__Value">{DateService.getMoment(state[formConfig.property]).format('YYYY-MM-DD HH:mm:ss Z') || '-'}</FieldValue>
                                        </Field>
                                        : null
            )}
        </FieldRow>
    ))
}


function CustomDatePicker({ id, value, onChangeData, disabled }) {
    function validateTimestamp(date, time) {
        return !!date && !!time && !isNaN(getUnixFromDateAndTime(date, time))
    }

    function getUnixFromDateAndTime(mom, time) {
        time = time || ''
        time = time.replace(/_/g, '0')
        const m = moment(`${mom.format('YYYYMMDD')}${time}`, 'YYYYMMDDHH:mm:ss', true)
        return m.valueOf()
    }

    const tsMoment = DateService.getMoment(parseInt(value)).isValid() ? DateService.getMoment(parseInt(value)) : null

    const [state, setState] = useState({
        date: tsMoment,
        time: !!tsMoment ? tsMoment.format('HH:mm:ss') : null
    })

    useEffect(() => {
        if (!!state.date && !!state.time && validateTimestamp(state.date, state.time)) {
            const value = getUnixFromDateAndTime(state.date, state.time)
            onChangeData(value)
        }
    }, [state])

    return (
        <div className="flex flex-space-between date-picker-container">
            <div className="flex-2 mr-5">
                <DatePicker
                    id={id}
                    customInput={<CustomDateInput invalid={false} />}
                    autoComplete="false"
                    selected={state.date}
                    onChange={(e) => {
                        setState({ ...state, date: e })
                    }}
                    maxDate={moment()}
                    dateFormat={DateService.getDateFormat()}
                    placeholderText={DateService.getDateFormat()}
                    fixedHeight
                    peekNextMonth
                    showYearDropdown
                    showMonthDropdown
                    disabled={disabled}
                />
            </div>
            <div className="flex-1 ml-5">
                <MaskedInput
                    type="text"
                    value={state.time}
                    onChange={(e) => {
                        setState({ ...state, time: e?.target?.value })
                    }}
                    mask="11:11:11"
                    disabled={disabled}
                />
            </div>
        </div>
    )
}

export const ContainerFields = styled.div`
input:focus {
    outline: none;
}

.field-date-picker {
    .date-picker-container {
        width: 25% !important;

        .input-group {
            width: 100% !important;
    
            .fa-calendar {
                display: none !important;
            }
        }
    }
}
`